import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import queryString from 'query-string';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import _has from 'lodash/has';
import _isEmpty from 'lodash/isEmpty';

import { UserSearchDetails } from './UserDetailsContext';

const useUserDetailsProvider = () => {
	const [selectedUser, setSelectedUser] = useState<any>();
	const [userSearchDetails, setUserSearchDetails] = useState<UserSearchDetails>({});
	const history = useHistory();

	const handleParseUserDetails = () => {
		const searchString = _get(history, ['location', 'search']);
		let parsedUser: UserSearchDetails = {};
		if (!_isNil(searchString) && !_isEmpty(searchString) && (_isNil(userSearchDetails) || _isEmpty(userSearchDetails))) {
			const searchParams = queryString.parse(searchString);
			if (_has(searchParams, 'uid')) {
				parsedUser = { selectionType: 'uid', selectedValue: Number(searchParams.uid) };
			} else if (_has(searchParams, 'phone')) {
				parsedUser = { selectionType: 'phone', selectedValue: String(searchParams.phone) };
			} else if (_has(searchParams, 'email')) {
				parsedUser = { selectionType: 'email', selectedValue: String(searchParams.email) };
			}
		}

		setUserSearchDetails(parsedUser);

		return parsedUser;
	};

	return {
		selectedUser,
		userSearchDetails,
		setUserSearchDetails,
		handleParseUserDetails,
		setSelectedUser
	};
};

export default useUserDetailsProvider;
